"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid from "@/components/grid/UiGrid.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import VirtualdesktopForm from "@/views/virtualdesktopItems/components/dialog-forms/VirtualdesktopForm.vue";
import API from "@ym-framework/api-utils";
let MultiMoveShops = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.guid = null;
    this.item_env = null;
    this.activestep = 0;
    this.errorMessage = null;
    this.errorTimeout = null;
    this.environment_id = null;
  }
  open(item) {
    return __async(this, null, function* () {
      this.item_env = item;
      this.guid = item.oldId;
      this.dialog.visible = true;
    });
  }
  closeMoveShop() {
    return __async(this, null, function* () {
      this.guid = null;
      this.item_env = null;
      this.activestep = 0;
      this.environment_id = null;
      this.dialog.visible = false;
    });
  }
  downloadmodel() {
    return __async(this, null, function* () {
      try {
        this.$message.success(this.$t("multimoveshops.getting_the_download_link_starting_the_download_later"));
        let downloadWin = window.open("", "_self");
        let response = yield API.get(`api://base.auth/api/v5/environment/export_plugin`);
        downloadWin.location.href = response.data.resource;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  CreateShop() {
    return __async(this, null, function* () {
      yield this._create_shop_dialog.open(null, this.item_env.id);
    });
  }
  showHelp() {
    return __async(this, null, function* () {
      window.open(`https://www.kuajingvs.com/help2/7760`, "_blank");
    });
  }
  elInFile(file) {
    return __async(this, null, function* () {
      try {
        this.errorMessage = null;
        clearTimeout(this.errorTimeout);
        if (file.name.indexOf(".zip") === -1) {
          this.errorMessage = this.$t("multimoveshops.upload_file_format_must_be");
          this.errorTimeout = setTimeout(() => {
            this.errorMessage = null;
          }, 5e3);
          return;
        }
        this.activestep = 1;
        const formdata = new window.FormData();
        formdata.append("file", file.raw);
        let response = yield API.post(`api://base.auth.pro/v1/environment/${this.guid}/check/file`, formdata);
        this.environment_id = response.data.id;
        this.activestep = 2;
      } catch (error) {
        this.activestep = 0;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  reload() {
    return __async(this, null, function* () {
      yield this.closeMoveShop();
      this.$emit("success");
    });
  }
};
__decorateClass([
  Ref("create-shop-dialog")
], MultiMoveShops.prototype, "_create_shop_dialog", 2);
MultiMoveShops = __decorateClass([
  Component({
    components: {
      UiGrid,
      UiDialog,
      VirtualdesktopForm
    }
  })
], MultiMoveShops);
export {
  MultiMoveShops as default
};
